// extracted by mini-css-extract-plugin
export default {"productGrid":"fZ-z","centerLink":"gZ-z","productSection":"hZ-z","item":"iZ-z","ctaButton":"jZ-z"};